import { useState } from "react";
import { FaTimes } from "react-icons/fa";

const CreateTagModal = ({ isOpen, onClose, handleCreateTag }) => {
  const [tagName, setTagName] = useState("");
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState("");

  const handleCreate = async () => {
    if (!tagName.trim()) {
      setError("Tag name is required");
      return;
    }

    setIsCreating(true);
    setError("");

    try {
      await handleCreateTag(tagName.trim());
      onClose();
      setTagName("");
    } catch (error) {
      console.error("Error creating tag:", error);
      setError("Failed to create tag. Please try again.");
    } finally {
      setIsCreating(false);
    }
  };

  const handleClose = () => {
    setTagName("");
    setError("");
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Escape") {
      handleClose();
    } else if (e.key === "Enter") {
      handleCreate();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
      <div className="bg-[#264984] rounded-lg shadow-xl w-96 max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-200">
            Create New Tag
          </h3>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-4">
          <div className="mb-4">
            <label
              htmlFor="tagName"
              className="block text-sm font-medium text-gray-200 mb-2"
            >
              Tag Name
            </label>
            <input
              type="text"
              id="tagName"
              value={tagName}
              onChange={(e) => setTagName(e.target.value)}
              onKeyDown={handleKeyPress}
              placeholder="Enter tag name..."
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              autoFocus
              disabled={isCreating}
            />
            {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
          </div>

          {/* Footer */}
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500"
              disabled={isCreating}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleCreate}
              disabled={!tagName.trim() || isCreating}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {isCreating ? "Creating..." : "Create Tag"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateTagModal;
